import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import lodashGet from 'lodash/get';
import { useChartData } from '../../context/ChartContext';
import { usePreferences } from '../../context/PreferencesContext';
import { SVGGroup } from '../../elements/SVGGroup';
import useSpectrum from '../../hooks/useSpectrum';
import { formatNumber } from '../../utility/formatNumber';
const styles = {
    label: {
        fontSize: '11px',
        fill: 'black',
        fontWeight: 'bold',
    },
    value: {
        fontSize: '12px',
        fill: 'black',
    },
    colorIndicator: {
        width: '10px',
        height: '2px',
    },
};
function getInfoValue(spectrum, field) {
    const { jpath, format } = field;
    const value = lodashGet(spectrum, jpath, '');
    switch (typeof value) {
        case 'number':
            return formatNumber(value, format);
        case 'string':
            return value;
        case 'boolean':
            return value ? 'Yes' : 'No';
        default:
            return JSON.stringify(value);
    }
}
function SpectrumInfoBlock() {
    const { margin } = useChartData();
    const spectrum = useSpectrum();
    const { current: { infoBlock: { visible, fields }, }, } = usePreferences();
    if (!visible || !spectrum)
        return null;
    return (_jsx("g", { className: "spectra-info-block", transform: `translate(${margin.left + 5} ${margin.top})`, children: fields
            .filter((field) => field.visible)
            .map((field, index) => {
            return (_jsxs(SVGGroup, { transform: `translate(0,${20 * (index + 1)})`, space: 5, children: [_jsxs("text", { alignmentBaseline: "middle", style: styles.label, children: [field.label, " :"] }), _jsx("text", { alignmentBaseline: "middle", style: styles.value, children: getInfoValue(spectrum, field) })] }, field.jpath + field.label));
        }) }));
}
export default SpectrumInfoBlock;
